module.exports = __webpack_public_path__ + "static/media/Medcare Women & Children Hospital.73841f09.jpg";